import api from './api';

export interface TipoEmendaDTO {
  id: number;
  codigo: string;
  nome: string;
  ativo: boolean;
  ordem: number;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

export const tipoEmendaService = {
  list: async (): Promise<TipoEmendaDTO[]> => {
    // Prefer /tipos-emenda (JIRA 2). If your proxy only forwards /api, you can switch to '/tipos-emenda' server-side.
    // With baseURL '/api', this will call '/api/tipos-emenda' which is also supported.
    const response = await api.get('/tipos-emenda');
    return response.data;
  },
};

export function resolveTipoEmendaNome(codigo: string | undefined | null, tipos: TipoEmendaDTO[] = []): string {
  if (!codigo) return '\u2014';
  const found = tipos.find(t => t.codigo === codigo);
  if (found) return found.nome;
  // fallback mapping for known constants to friendly labels (in case tipos list hasn't loaded)
  const map: Record<string, string> = {
    'EMENDA_INDIVIDUAL_TRANSFERENCIA_FINALIDADE_DEFINIDA': 'Emenda Individual - Transferência (Finalidade Definida)'
  };
  return map[codigo] ?? codigo;
}

export default tipoEmendaService;
